import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import { checkWorkPlaceNowAPI } from '../../../../api/workPlace/workPlaceAPI'
import ErrorMessage from '../../../../helpers/message/ErrorMessage'
import SuccessMessage from '../../../../helpers/message/SuccessMessage'
import MySpiner from '../../../UI/spiner/MySpiner'
import UserWorkPlaceVisibleData from './UserWorkPlaceVisibleData'

const UserWorkPlaceVisible = () => {

    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkWorkPlaceNow()
    }, [])

    const checkWorkPlaceNow = () => {
        setError('')
        setLoading(true)
        setData(null)
        checkWorkPlaceNowAPI().then(data => {
            setData(data)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            // setErrorMain(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myBlock__content'>
        <p>
            Сторінка для початку та закінчення робочої зміни. Відскануйте QR-код якщо прийшли на роботу або закінчуєте роботу
        </p>
        
        <ErrorMessage
            error={error}
        />
        <SuccessMessage 
            success={success}
        />

        {
            loading ?
                <MySpiner />
            : ''
        }

        {
            data ?
                <UserWorkPlaceVisibleData 
                    result={data}
                />
            : ''
        }

    </div>
  )
}

export default UserWorkPlaceVisible